import React from 'react';

export default function Team() {
  return (
    <div>
      <div>
      <div className='page'>
        <div className='about_Container'>
          <div className='box1'>
            <h1 className='pagetitle'>Our team</h1>
            <div className='discription'>
              Join Our Fitness Family <br></br>
              Find Your Perfect Class Time <br></br>
              Train Together, Grow Together
            </div>
          </div>
          <div className='box2'>
            <img className='models2' src='/images/men-workout.jpeg' alt='Models2' />
            <img className='models3' src='/images/schedule.png' alt='Models2' />
          </div>
        </div>
        <div className='about_Container5'>
          <div className='pagetitle'>Our Excellent Team Members</div>
          <div className='scrollBox'>
            <div className='scrollcard'>
              <img className='teamMembers' src='/images/medical-assistant-preparing-physiotherapy-exercises.jpg' alt='Models2' />
              <div className='intro'>
                <h3 className='cardName'>Name1</h3>
                <p className='cardDetails'>Details of the Doctor/Couch</p>
              </div>
            </div>
            <div className='scrollcard'>
              <img className='teamMembers' src='/images/medical-assistant-preparing-physiotherapy-exercises.jpg' alt='Models2' />
              <div className='intro'>
                <h3 className='cardName'>Name2</h3>
                <p className='cardDetails'>Details of the Doctor/Couch</p>
              </div>
            </div>
            <div className='scrollcard'>
              <img className='teamMembers' src='/images/medical-assistant-preparing-physiotherapy-exercises.jpg' alt='Models2' />
              <div className='intro'>
                <h3 className='cardName'>Name3</h3>
                <p className='cardDetails'>Details of the Doctor/Couch</p>
              </div>
            </div>
            <div className='scrollcard'>
              <img className='teamMembers' src='/images/medical-assistant-preparing-physiotherapy-exercises.jpg' alt='Models2' />
              <div className='intro'>
                <h3 className='cardName'>Name4</h3>
                <p className='cardDetails'>Details of the Doctor/Couch</p>
              </div>
            </div>
            <div className='scrollcard'>
              <img className='teamMembers' src='/images/medical-assistant-preparing-physiotherapy-exercises.jpg' alt='Models2' />
              <div className='intro'>
                <h3 className='cardName'>Name5</h3>
                <p className='cardDetails'>Details of the Doctor/Couch</p>
              </div>
            </div>
            <div className='scrollcard'>
              <img className='teamMembers' src='/images/medical-assistant-preparing-physiotherapy-exercises.jpg' alt='Models2' />
              <div className='intro'>
                <h3 className='cardName'>Name6</h3>
                <p className='cardDetails'>Details of the Doctor/Couch</p>
              </div>
            </div>
            <div className='scrollcard'>
              <img className='teamMembers' src='/images/medical-assistant-preparing-physiotherapy-exercises.jpg' alt='Models2' />
              <div className='intro'>
                <h3 className='cardName'>Name7</h3>
                <p className='cardDetails'>Details of the Doctor/Couch</p>
              </div>
            </div>            
            <div className='scrollcard'>
              <img className='teamMembers' src='/images/medical-assistant-preparing-physiotherapy-exercises.jpg' alt='Models2' />
              <div className='intro'>
                <h3 className='cardName'>Name8</h3>
                <p className='cardDetails'>Details of the Doctor/Couch</p>
              </div>
            </div>
            <div className='scrollcard'>
              <img className='teamMembers' src='/images/medical-assistant-preparing-physiotherapy-exercises.jpg' alt='Models2' />
              <div className='intro'>
                <h3 className='cardName'>Name9</h3>
                <p className='cardDetails'>Details of the Doctor/Couch</p>
              </div>
            </div>
            <div className='scrollcard'>
              <img className='teamMembers' src='/images/medical-assistant-preparing-physiotherapy-exercises.jpg' alt='Models2' />
              <div className='intro'>
                <h3 className='cardName'>Name10</h3>
                <p className='cardDetails'>Details of the Doctor/Couch</p>
              </div>
            </div>
            <div className='scrollcard'>
              <img className='teamMembers' src='/images/medical-assistant-preparing-physiotherapy-exercises.jpg' alt='Models2' />
              <div className='intro'>
                <h3 className='cardName'>Name11</h3>
                <p className='cardDetails'>Details of the Doctor/Couch</p>
              </div>
            </div>
            <div className='scrollcard'>
              <img className='teamMembers' src='/images/medical-assistant-preparing-physiotherapy-exercises.jpg' alt='Models2' />
              <div className='intro'>
                <h3 className='cardName'>Name12</h3>
                <p className='cardDetails'>Details of the Doctor/Couch</p>
              </div>
            </div>
            
          </div >
        </div>
      </div>
    </div>
  </div>
  );
}